"use client";

import { useTranslations } from "next-intl";
import Image from "next/image";

const interests = [
	{ id: "blockchain", image: "/assets/vendors/blockchain.png" },
	{ id: "cloudComputing", image: "/assets/vendors/cloud-computing.png" },
	{ id: "ai", image: "/assets/vendors/artificial-intelligence.png" },
	{ id: "machineLearning", image: "/assets/vendors/machine-learning.png" },
	{ id: "rpa", image: "/assets/vendors/rpa.png" },
	{
		id: "dataAnalytics",
		image: "/assets/vendors/data-analytics-visualization.png",
	},
];

export default function InterestsSection() {
	const t = useTranslations("Interests");

	return (
		<section className="relative min-h-[75rem] bg-[#ccf5ff] rounded-br-[20%_12%]">
			{/* Wave decorative top */}
			<div
				className="absolute top-0 left-0 w-full h-[31rem] bg-no-repeat bg-cover"
				style={{ backgroundImage: "url(/assets/vendors/wave-top4.png)" }}
			/>
			<div className="relative w-full section-padding pt-[25rem] pb-20">
				<h3 className="text-[2.8rem] font-normal text-black pt-6 px-6">
					{t("title")}
				</h3>
				{/* Margin before the grid; two rows of 3 on large screens; .interests-grid adds margin-left on lg */}
				<div className="interests-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-24 lg:mt-32 justify-items-start">
					{interests.map((item) => (
						<div key={item.id} className="flex items-center px-6 py-4 min-w-0">
							<div className="relative w-16 h-16 flex-shrink-0">
								<Image
									src={item.image}
									alt={t(item.id)}
									fill
									sizes="64px"
									className="object-contain align-middle"
								/>
							</div>
							<span className="text-[1.8rem] ml-2 text-black">
								{t(item.id)}
							</span>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
